export default __webpack_public_path__ + "static/media/7.280e4fc9.png";